// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-bold {
  font-weight: bold !important;
}
.padding-20 {
  padding: 20px;
}

.ptn-log-center {
  text-align: center;
  margin: 20 0;
 
  color: #005a2d;
}

.ptn-log-center * {
  font-size: 20px;
  color: #ffffff;
}


.ptn-mla-logo img{
  height: 65px;
}

#mobile-ptn-image, #desktop-ptn-image{
  height: 50px;
  width: 120px;
  margin-top: 5px;
  margin-left:75px;
}




.ptn-questions,
.ptn-email {
  font-size: 10px;
  color: #ffffff;
  margin: 10px 0;
}
.ptn-log-center .developed-by {
  font-size: 10px;
  color: #000000;
  margin: 10px 0;
}

.header-row {
  background-color: #ffffff;
  font-weight: bold;
}
.header-row th {
  padding: 10px;
  background-color: #ffffff;
  color: #333333;
  font-weight: bold;
  font-size: 1.3em;
}

.header-row td {
 
  font-size: 1.0em;
}

.header-row td span.resultSpan, span.resultSpan {
  color: #555555;
  
}

`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;;EAEZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;;;;AAKA;;EAEE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;;AAEhB","sourcesContent":[".text-bold {\n  font-weight: bold !important;\n}\n.padding-20 {\n  padding: 20px;\n}\n\n.ptn-log-center {\n  text-align: center;\n  margin: 20 0;\n \n  color: #005a2d;\n}\n\n.ptn-log-center * {\n  font-size: 20px;\n  color: #ffffff;\n}\n\n\n.ptn-mla-logo img{\n  height: 65px;\n}\n\n#mobile-ptn-image, #desktop-ptn-image{\n  height: 50px;\n  width: 120px;\n  margin-top: 5px;\n  margin-left:75px;\n}\n\n\n\n\n.ptn-questions,\n.ptn-email {\n  font-size: 10px;\n  color: #ffffff;\n  margin: 10px 0;\n}\n.ptn-log-center .developed-by {\n  font-size: 10px;\n  color: #000000;\n  margin: 10px 0;\n}\n\n.header-row {\n  background-color: #ffffff;\n  font-weight: bold;\n}\n.header-row th {\n  padding: 10px;\n  background-color: #ffffff;\n  color: #333333;\n  font-weight: bold;\n  font-size: 1.3em;\n}\n\n.header-row td {\n \n  font-size: 1.0em;\n}\n\n.header-row td span.resultSpan, span.resultSpan {\n  color: #555555;\n  \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
